<script>
import appConfig from "@/app.config";
import Cookies from 'js-cookie'
import NavBarAuth from '@/components/navbar-auth';
import FooterAuth from '@/components/footer-auth';

import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

/**
 * Register component
 */
export default {
  name: "Register",
  page: {
    title: "Register",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { NavBarAuth, FooterAuth },
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        phone: "",
        address: "",
        industry_id: null,
        province_id: null,
        city_id: null,
        zip_code: "",
        contact_person: "",
      },
      isRegisterError: false,
      errorMessage: "",
      isRegisterSucces: false,
      successMessage: "",
      industryList: [],
      provinceList: [],
      cityList: [],
      submited: false,
      isPasswordShowed: false
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      password: {
        required,
        minLength: minLength(8),
        strength: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        }
      },
      phone: { required, minLength: minLength(8), maxLength: maxLength(15) },
      address: { required },
      industry_id: { required },
      province_id: { required },
      city_id: { required },
      zip_code: { required },
      contact_person: { required },
    }
  },
  created() {
    this.getIndustries()
    this.getProvinces()
  },
  computed: {
    inputPasswordType() {
      return this.isPasswordShowed ? 'text' : 'password';
    }
  },
  mounted() {
    this.cityList.push({ value: null, text: this.$t('form.placeholder.select_province_first') })
  },
  methods: {
    async tryToRegister() {
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // hit api disini
        this.$axios.post('/v1/logistic_company/register', this.form)
          .then(response => {
            let userdata = response.data.data;
            this.$store.commit("SET_LOGIN", userdata);
            Cookies.set("userdata", JSON.stringify(userdata), { expires: 1 }); 
            this.submited = true;
            this.isRegisterSucces = true;
            this.successMessage = response.data.message;
            setTimeout(() => {
              window.location.href = '/profile-update';
            }, 1000)
          }).catch(error => {
            this.isRegisterError = true;
            this.errorMessage = error.response.data.message;
          })
      }
    },
    getIndustries() {
      this.$axios.get('/v1/industry', {
        params: {
          page: 1,
          per_page: 100,
          orderby: 'name',
          sort: 'asc',
          status: 'aktif'
        }
      })
        .then(response => {
          this.industryList = response.data.data.rows.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.industryList.unshift({ value: null, text: this.$t('form.placeholder.select_industry') })
        })
    },
    getProvinces() {
      this.$axios.get('/v1/province')
        .then(response => {
          this.provinceList = response.data.data.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.provinceList.unshift({ value: null, text: this.$t('form.placeholder.select_province') })
        })
    },
    getCities() {
      this.$axios.get('/v1/cities', {
        params: {
          province_id: this.form.province_id
        }
      })
        .then(response => {
          this.cityList = response.data.data.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.cityList.unshift({ value: null, text: this.$t('form.placeholder.select_city') })
        })
    }
  }
};
</script>

<template>
  <div class="front-page account-pages my-5 pt-5">
    <NavBarAuth />
    <div class="front-bg"></div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="card overflow-auto" style="max-height: 550px">
            <div class="text-semi-black text-center pt-5 pb-1">
              <h1>{{ $t('auth.register_title') }}</h1>
            </div>

            <div class="card-body px-5 pt-0">
              <div class="p-3">

                <b-form @submit.prevent="tryToRegister" class="form-horizontal mt-4">
                  <div class="form-group row mb-0">
                    <div class="col-lg-6">
                      <b-form-group id="name-group" :label="$t('form.field.name')" label-for="name">
                        <b-form-input
                          id="name"
                          name="name"
                          v-model.trim="form.name"
                          type="text"
                          :class="{ 'is-invalid': $v.form.name.$error }"
                        ></b-form-input>
                        <div v-if="$v.form.name.$error" class="invalid-feedback">
                          <span v-if="!$v.form.name.required">{{ $t('form.validation.required', { field: $t('form.field.name') }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-lg-6">
                      <b-form-group id="email-group" label="Email" label-for="email">
                        <b-form-input
                          id="email"
                          name="email"
                          v-model.trim="form.email"
                          type="text"
                          :class="{ 'is-invalid': $v.form.email.$error }"
                        ></b-form-input>
                        <div v-if="$v.form.email.$error" class="invalid-feedback">
                          <span v-if="!$v.form.email.required">{{ $t('form.validation.required', { field: 'Email' }) }}</span>
                          <span v-if="!$v.form.email.email">{{ $t('form.validation.email', { field: 'Email' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-group id="phone-group" :label="$t('form.field.phone')" label-for="phone">
                    <b-form-input
                      id="phone"
                      name="phone"
                      v-model.trim="form.phone"
                      type="text"
                      :class="{ 'is-invalid': $v.form.phone.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.phone.$error" class="invalid-feedback">
                      <span v-if="!$v.form.phone.required">{{ $t('form.validation.required', { field: $t('form.field.phone') }) }}</span>
                      <span v-if="!$v.form.phone.minLength">{{ $t('form.validation.min_length', { field: $t('form.field.phone'), length: 8 }) }}</span>
                      <span v-if="!$v.form.phone.maxLength">{{ $t('form.validation.max_length', { field: $t('form.field.phone'), length: 15 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="address-group" :label="$t('form.field.address')" label-for="address">
                    <b-textarea
                      id="address"
                      name="address"
                      v-model.trim="form.address"
                      :class="{ 'is-invalid': $v.form.address.$error }"
                      rows="5"
                    ></b-textarea>
                    <div v-if="$v.form.address.$error" class="invalid-feedback">
                      <span v-if="!$v.form.address.required">{{ $t('form.validation.required', { field: $t('form.field.address') }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="industry-group" :label="$t('form.field.industry')" label-for="industry">
                    <b-form-select
                      id="industry"
                      name="industry"
                      v-model.trim="form.industry_id"
                      :options="industryList"
                      :class="{ 'is-invalid': $v.form.industry_id.$error }"
                    ></b-form-select>
                    <div v-if="$v.form.industry_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.industry_id.required">{{ $t('form.validation.required', { field: $t('form.field.industry') }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="province-group" :label="$t('form.field.province')" label-for="province">
                    <b-form-select
                      id="province"
                      name="province"
                      v-model.trim="form.province_id"
                      :options="provinceList"
                      :class="{ 'is-invalid': $v.form.province_id.$error }"
                      @change="getCities"
                    ></b-form-select>
                    <div v-if="$v.form.province_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.province_id.required">{{ $t('form.validation.required', { field: $t('form.field.province') }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="city-group" :label="$t('form.field.city')" label-for="city">
                    <b-form-select
                      id="city"
                      name="city"
                      v-model.trim="form.city_id"
                      :options="cityList"
                      :class="{ 'is-invalid': $v.form.city_id.$error }"
                    ></b-form-select>
                    <div v-if="$v.form.city_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.city_id.required">{{ $t('form.validation.required', { field: $t('form.field.city') }) }}</span>
                    </div>
                  </b-form-group>

                  <div class="form-group row mb-0">
                    <div class="col-sm-6">
                      <b-form-group id="zip_code-group" :label="$t('form.field.postal_code')" label-for="zip_code">
                        <b-form-input
                          id="zip_code"
                          name="zip_code"
                          v-model.trim="form.zip_code"
                          :class="{ 'is-invalid': $v.form.zip_code.$error }"
                          type="text"
                        ></b-form-input>
                        <div v-if="$v.form.zip_code.$error" class="invalid-feedback">
                          <span v-if="!$v.form.zip_code.required">{{ $t('form.validation.required', { field: $t('form.field.postal_code') }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6">
                      <b-form-group id="contact-group" :label="$t('form.field.personal_contact')" label-for="contact">
                        <b-form-input
                          id="contact"
                          name="contact"
                          v-model.trim="form.contact_person"
                          :class="{ 'is-invalid': $v.form.contact_person.$error }"
                          type="text"
                        ></b-form-input>
                        <div v-if="$v.form.contact_person.$error" class="invalid-feedback">
                          <span v-if="!$v.form.contact_person.required">{{ $t('form.validation.required', { field: $t('form.field.personal_contact') }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  
                  <b-form-group id="password-group" label="Password" label-for="password" class="input-password">
                    <b-form-input
                      id="password"
                      name="password"
                      v-model.trim="form.password"
                      :type="inputPasswordType"
                      :class="{ 'is-invalid': $v.form.password.$error }"
                    ></b-form-input>
                    <i class="fas pass-icon" :class="[ isPasswordShowed ? 'fa-eye' : 'fa-eye-slash']" @click="isPasswordShowed = !isPasswordShowed"></i>
                    <div v-if="$v.form.password.$error" class="invalid-feedback">
                      <span v-if="!$v.form.password.required">{{ $t('form.validation.required', { field: 'Password' }) }}</span>
                      <span v-if="!$v.form.password.minLength">{{ $t('form.validation.min_length', { field: 'Password', length: 8 }) }}</span>
                      <span v-if="!$v.form.password.strength">{{ $t('form.validation.password_strength') }}</span>
                    </div>
                  </b-form-group>

                  <p class="text-black-50 mt-2">
                    Dengan mengklik Daftar, Anda menyetujui
                    <a class="text-danger font-weight-bolder" target="_blank" href="https://aex.demoapp.xyz/syarat-ketentuan/">
                      <u>Syarat & Ketentuan</u>
                    </a>
                    yang berlaku.
                  </p>

                  <b-alert
                    v-model="isRegisterError"
                    class="mt-3"
                    variant="danger"
                    dismissible
                  >{{ errorMessage }}</b-alert>

                  <b-alert
                    v-model="isRegisterSucces"
                    class="mt-3"
                    variant="success"
                    dismissible
                  >{{ successMessage }}</b-alert>

                  <div class="form-group row">
                    <div class="col-sm-12 ">
                      <b-button type="submit" variant="danger" size="lg" class="w-100" :class="{ 'cursor-block': submited }" :disabled="submited">{{ $t('auth.register') }}</b-button>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <FooterAuth />
  </div>
</template>

<style lang="scss" module></style>
